<template>
  <el-container v-loading="loading" element-loading-text="Ładowanie projektów...">
    <el-main class="main">
      <Logo />
      <p>W Twoim zamówieniu znajdują się następujące projekty. Wybierz projekt który chcesz edytować:</p>
        <el-row class="templates" justify="center" type="flex">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="4"
            v-for="(template, index) in templates"
            :key="index"
            style="padding-left: 10px; padding-right: 10px;" 
          >
            <TemplateTile :template="template" :urlSuffix="suffix"/>
          </el-col>
        </el-row>
    </el-main>
  </el-container>
</template>

<script>
  import TemplateTile from '../components/Home/TemplateTile.vue';
  import { GraphQLClient, gql } from 'graphql-request';
  import Logo from '../components/Common/Logo.vue'
  
  export default {
    name: 'Projects',
    data() {
      return {
        code: '',
        loading: true,
        error: false,
        templates: []
      }
    },
    computed: {
      suffix() {
        return `/${this.$route.params.orderId}`
      }
    },
    async mounted() {

      const routeId = this.$route.params.id || null;
      const projects = routeId.split(',').map((project) => {
        const codes = project.split('-')
        const code = codes.filter((part, index) => index <= 1).join('-')
        return code.trim().toLowerCase()
      })

      const endpoint = location.hostname !== 'localhost' ? `https://editello.com/graphql` : 'http://localhost:8082/graphql'

      const graphQLClient = new GraphQLClient(endpoint, {
        credentials: 'include',
        mode: 'cors',
        headers: {
          // authorization: 'Bearer MY_TOKEN',
        },
      })

      const query = gql`
        {
          drafts {
            name,
            code,
            preview
          }
        }
      `

      const data = await graphQLClient.request(query)

      this.loading = false;
      this.templates = data.drafts;

      this.templates = data.drafts.filter((template) => projects.includes(template.code.toLowerCase()))
      
    },
    components: {
      Logo,
      TemplateTile
    }
  }
</script>

<style lang="less" scoped>

p {
  max-width: 500px;
  margin: 15px auto 30px;
  color: rgb(146, 146, 146);
}

.templates {
  width: 100%;
  margin-top: 30px;
}

.el-main.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
</style>